import React from 'react';
import { X, Home } from 'lucide-react';
import './FilterBar.css';

const CATEGORIES = ['all', 'home', 'errands', 'finance', 'health', 'work', 'personal', 'educational'];
const PRIORITIES = ['all', 'high', 'medium', 'low'];
const STATUSES = ['all', 'pending', 'completed'];

export default function FilterBar({ filter, onFilterChange, onGoHome, showHomeButton }) {
  const set = (key, val) => onFilterChange(prev => ({ ...prev, [key]: val }));
  const clearDueDate = () => onFilterChange(prev => ({ ...prev, dueDate: undefined }));

  return (
    <div className="filter-bar fade-in">
      {filter.dueDate && (
        <div className="filter-group due-date-filter">
          <span className="filter-label">Date Filter</span>
          <div className="filter-pills">
            <button className="pill active due-date-pill">
              {new Date(filter.dueDate).toLocaleDateString('en-US', { 
                month: 'short', 
                day: 'numeric',
                year: 'numeric'
              })}
              <X size={14} onClick={(e) => { e.stopPropagation(); clearDueDate(); }} className="clear-icon" />
            </button>
          </div>
        </div>
      )}

      {showHomeButton && onGoHome && (
        <div className="filter-group home-button-group">
          <button className="home-nav-btn" onClick={onGoHome}>
            <Home size={16} />
            <span>Dashboard</span>
          </button>
        </div>
      )}

      <div className="filter-group">
        <span className="filter-label">Status</span>
        <div className="filter-pills">
          {STATUSES.map(s => (
            <button
              key={s}
              className={`pill ${filter.status === s ? 'active' : ''}`}
              onClick={() => set('status', s)}
            >
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>
      </div>

      <div className="filter-group">
        <span className="filter-label">Category</span>
        <div className="filter-pills">
          {CATEGORIES.map(c => (
            <button
              key={c}
              className={`pill ${filter.category === c ? 'active' : ''}`}
              onClick={() => set('category', c)}
            >
              {c.charAt(0).toUpperCase() + c.slice(1)}
            </button>
          ))}
        </div>
      </div>

      <div className="filter-group">
        <span className="filter-label">Priority</span>
        <div className="filter-pills">
          {PRIORITIES.map(p => (
            <button
              key={p}
              className={`pill pill-${p} ${filter.priority === p ? 'active' : ''}`}
              onClick={() => set('priority', p)}
            >
              {p.charAt(0).toUpperCase() + p.slice(1)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
